import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useScrollDirection from "hooks/useScrollDirection";
import "./bottomNavigation.scss";

const menu = [
    { name: "홈", link: "", icon: "home_ico.svg", src: "icon-home" },
    {
        name: "예약",
        link: "reservation",
        icon: "calendar.svg",
        src: "icon-reservation",
    },
    {
        name: "커뮤니티",
        link: "community",
        icon: "community_ico.svg",
        src: "icon-community",
    },
    {
        name: "투어",
        link: "tour",
        icon: "travel_ico.svg",
        src: "icon-travel",
    },
    {
        name: "마이버클",
        link: "mybuccl",
        icon: "my_ico.svg",
        src: "icon-mybuccl",
    },
];

function BottomNavigation() {
    const location = useLocation();
    const navigate = useNavigate();
    const currentPath = location.pathname;
    const scrollDirection = useScrollDirection({ resetKey: currentPath });
    const isHidden = scrollDirection === "down";

    // 네비바가 숨을 때 body 에 클래스를 달아, body 로 portal 된 FAB(예: 커뮤니티 글쓰기 버튼)이
    // CSS 만으로 함께 내려오거나 사라지도록 신호를 준다.
    useEffect(() => {
        document.body.classList.toggle("bottom-nav-hidden", isHidden);
        return () => document.body.classList.remove("bottom-nav-hidden");
    }, [isHidden]);

    const handleMenuClick = (link) => {
        if (link === "reservation") {
            navigate(`/${link}?type=class`);
        } else {
            navigate(`/${link}`);
        }
    };

    return (
        <nav
            className={`bottom-navigation ${isHidden ? "hidden" : ""}`}
            aria-hidden={isHidden}
        >
            <div className="bottom-nav-container">
                {menu.map((m) => {
                    const targetPath = `/${m.link}`;
                    const isActive =
                        currentPath === targetPath ||
                        (m.link === "" && currentPath === "/");
                    return (
                        <div
                            key={m.icon}
                            className="bottom-nav-link-item"
                            onClick={() => handleMenuClick(m.link)}
                        >
                            <i
                                alt={m.name}
                                className={`icon bottom-nav-icon ${
                                    isActive ? "active" : ""
                                } ${m.src}`}
                            />
                            <span
                                className={`nav-title ${
                                    isActive ? "active" : ""
                                }`}
                            >
                                {m.name}
                            </span>
                        </div>
                    );
                })}
            </div>
        </nav>
    );
}

export default BottomNavigation;
